<mat-checkbox
  (change)="toggle.emit([fieldId, item])"
  [checked]="item.checked"
  [title]="item.label + ' (' + item.count + ')'"
  class="primary-checkbox"
  >
  @if (fieldId === 'GulliverRecScore') {
    <cat-ui-score [score]="+item.label" class="mr-1"></cat-ui-score>
  }
  @if (fieldId !== 'GulliverRecScore') {
    <span class="mr-1 whitespace-nowrap">{{ item.label }}</span>
  }

  <span>({{ item.count }})</span>
</mat-checkbox>
